'use client'
import NavWithScroll from "@/revamp/molecules/NavWithScroll/NavWithScroll";
import NavWithScrollLandingPageMBA from "@/components/LandingPageMBA/NavWithScrollLandingPageMBA/NavWithScrollLandingPageMBA";
import styles from "./SecondaryMenu.module.scss";
import cn from "clsx";
import { useSearchParams } from "next/navigation";


const targetsList = {
  aboutUs: {
    0: "AboutUniversity",
    1: "Vision&Mission",
    2: "Values",
    3: "AmityOnlineAdvantages",
    4: "Leadership",
    5: "OurJourney",
  },
  default: {
    0: "overview",
    1: "ProgramHighlights",
    2: "Curriculum",
    3: "DegreeOffered",
    4: "Specialization",
    5: "eligibility",
    6: "Fees",
    7: "careers",
    8: "faculty",
  },
};

export default function SecondaryMenuSection({
  SecondaryMenu,
  isMobile,
  targetsType,
  CTA,
  isProgramDetailsPage,
  isCampusImmersionPage = false,
  programName = "",
  programType = "",
  duration="",
  overview = "",
  programHighlights= [],
  Specialization = [],
  EligibilityCriteria = [],
  CareerImpact= [],
  FEES = [],
  Faculty = [],
  isRFIDisabled = false,
  isMbaPage=false,
  useLandingPageMBAMenu=false
}: {
  SecondaryMenu: any;
  isMobile?: boolean;
  targetsType?: "aboutUs" | "default";
  CTA:any,
  isProgramDetailsPage?:boolean
  isCampusImmersionPage?:boolean;
  programName?: string;
  programType?: string;
  duration?: string;
  overview?: string 
  programHighlights?: any 
  Specialization?: any 
  EligibilityCriteria?: any 
  CareerImpact?: any 
  FEES?: any 
  Faculty?: any
  isRFIDisabled?: boolean
  isMbaPage?: boolean
  useLandingPageMBAMenu?: boolean
}) {

  const searchParams = useSearchParams();
  const amsType = searchParams?.get("AMSType") || "";

  if (!SecondaryMenu?.enabled) return null;

  return (
    <div
      id="secondary-menu"
      data-sticky-tabs
      className={cn(styles.SecondaryMenu__container, "container", {
        ["!mt-6 lg:!mt-10"]: targetsType === "aboutUs",
      })}
      style={amsType === "Jiopc" ? { top: "80px" } : {}}
    >
      {useLandingPageMBAMenu ? (
      <NavWithScrollLandingPageMBA
       isMobile={isMobile}
          data={SecondaryMenu?.Text}
          targets={targetsList[targetsType || "default"]}
          CTA={CTA} 
          isProgramDetailsPage={isProgramDetailsPage}
          isCampusImmersionPage={isCampusImmersionPage}
          programName={programName}
          programType={programType}
          duration={duration}
          overview={overview}
          programHighlights={programHighlights}
          Specialization={Specialization}
          EligibilityCriteria={EligibilityCriteria}
          FEES={FEES}
          CareerImpact={CareerImpact}
          Faculty={Faculty}
          isRFIDisabled={isRFIDisabled} 
        />
      ):(
        <NavWithScroll
          isMobile={isMobile}
          data={SecondaryMenu?.Text}
          targets={targetsList[targetsType || "default"]}
          CTA={CTA} 
          isProgramDetailsPage={isProgramDetailsPage}
          isCampusImmersionPage={isCampusImmersionPage}
          isMbaPage={isMbaPage}
          programName={programName}
          programType={programType}
          duration={duration}
          overview={overview}
          programHighlights={programHighlights}
          Specialization={Specialization}
          EligibilityCriteria={EligibilityCriteria}
          FEES={FEES}
          CareerImpact={CareerImpact}
          Faculty={Faculty}
          isRFIDisabled={isRFIDisabled}
          
        />
      )}
    </div>
  );
}
